import React, { useContext, useState, useRef, useEffect } from "react";
import { FormGroup, Form, Input, Label, Button, Row, Col, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import UserContext from "./UserContext";

const TenantValidationLoginForm = () => {
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const { loginTenantPortal } = useContext(UserContext);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    async function handleSubmit(evt) {
        evt.preventDefault();
        if (!isMounted.current) return;

        setLoading(true);
        try {
            const result = await loginTenantPortal(username, password);
            if (!result?.success && isMounted.current) {
                setPassword("");
            }
        } finally {
            if (isMounted.current) setLoading(false);
        }
    }

    return (
        <section className="auth-page">
            {loading ? (
                <Spinner color="primary" />
            ) : (
                <Row className="justify-content-center m-0 w-100">
                    <Col
                        xs={12}
                        sm={10}
                        md={6}
                        lg={4}>
                        <div className="auth-card">
                            <h4>Tenant Validation Portal</h4>
                            <p style={{ fontSize: "0.92rem", opacity: 0.85 }}>Use your tenant portal credentials to print labels, validate tickets, and view usage history.</p>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <Label htmlFor="tenantPortalUsername">Username</Label>
                                    <Input
                                        id="tenantPortalUsername"
                                        type="text"
                                        autoComplete="username"
                                        value={username}
                                        onChange={(evt) => setUsername(evt.target.value)}
                                        placeholder="tenant username"
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="tenantPortalPassword">Password</Label>
                                    <Input
                                        id="tenantPortalPassword"
                                        type="password"
                                        autoComplete="current-password"
                                        value={password}
                                        onChange={(evt) => setPassword(evt.target.value)}
                                        placeholder="password"
                                    />
                                </FormGroup>
                                <Button
                                    type="submit"
                                    color="success"
                                    disabled={loading || !username.trim() || !password}>
                                    Login
                                </Button>
                            </Form>
                            <div style={{ marginTop: "0.75rem", fontSize: "0.9rem" }}>
                                <Link to="/forgot-password?portal=tenant">Forgot password?</Link>
                            </div>
                            <div style={{ marginTop: "0.75rem", fontSize: "0.9rem" }}>
                                <Link to="/">Back to Home</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            )}
        </section>
    );
};

export default TenantValidationLoginForm;
